<template>
  <a href="javascript:;" @click="download()" class="downall">{{ text }}</a>
</template>

<script>
export default {
  name: "download",
  props: {
      url: String,
      params: Object,
      words: Array,
      separator: {
          type: String,
          default: ''
      }
  },
  data() {
      return{
          text: '下载全部',
          title: ''
      }
  },
  methods: {
    download() {
      let _this = this;
      _this.text = '下载中...'
      this.$http({
        url: _this.url,
        method: "post",
        crossdomain: true,
        params: _this.params,
        responseType: "blob",
      })
        .then(function (res) {
          try {
            // let enc = new TextDecoder("utf-8");
            let data = JSON.parse(res.data);
            console.log(data)
          } catch (error) {
            const data = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            });
            _this.to_title();
            if(window.navigator.msSaveBlob){
              window.navigator.msSaveBlob(data,_this.title + '.xlsx');//此方法即可下载成功
            }else{
              const download_url = URL.createObjectURL(data);
              const a = document.createElement("a");
              a.href = download_url;
              a.download = _this.title + '.xlsx';
              a.click();
              URL.revokeObjectURL(download_url);
            }
            _this.text = '下载全部'
          }
        })
        .catch(function (error) {
            _this.text = '下载全部'
          if (error.response == undefined) {
            return false;
          }
          switch (error.response.status) {
            case 401:
              _this.inquiryShow = true;
              break;
          }
        });
    },
    to_title() {
      this.title = '';
      let _this = this;
      let arr = this.words.filter(i=>i)
      arr.forEach((value,index) =>
        value !== "" ? ((_this.title !== '' && index > 1)? _this.title += _this.separator + value : _this.title += value) : 0
      );
    },
  },
};
</script>